// extracted by mini-css-extract-plugin
export default {"headerText":"third-party-login-component_headerText__C50OK","infoText":"third-party-login-component_infoText__tLH4r","boldText":"third-party-login-component_boldText__i+p7T"};